export default "__VITE_ASSET__BAiYPIrp__"